import {
    makeid,
    isLocalHost
} from '../helpers/CoreHelpers'
import jwtDecode from "jwt-decode";
import {oldToken} from '../store/actions/user'

export default {
    'name': process.env.APP_NAME,
    'api': {
        'endpoint': process.env.API_ENDPOINT,
        'cdn': process.env.CDN_ENDPOINT,
        getCdnEndPoint(){
            if (this.cdn){
                return this.cdn
            } else {
                return this.endpoint;
            }
        }
    },
    'language': process.env.LANGUAGE ? process.env.LANGUAGE : "he",
    'prefix': 'csod-awave--',
    'adminURL': document.getElementById('application').getAttribute('data-admin-url'),
    'frontURL': document.getElementById('application').getAttribute('data-front-url'),
    'client': document.getElementById('application').getAttribute('data-client'),
    'renderer': document.getElementById('application').getAttribute('data-renderer'),
    'initialRoute':document.getElementById('application').getAttribute('data-initial-route'),
    destroy(key){
        localStorage.removeItem(this.getStoragePrefixes(key));
    },
    set(key, value) {
        localStorage.setItem(this.getStoragePrefixes(key), value);
    },
    get(key) {
        let value = null;
        value = localStorage.getItem(this.getStoragePrefixes(key));

        if (value === "true") {
            return true;
        }
        if (value === "null") {
            return null;
        }
        if (value === "false") {
            return null;
        }

        return value;
    },
    clearStorage() {
        this.destroy('apitoken');
        this.destroy('user');
        this.destroy('ssoId');
    },
    setToken(token) {
        this.set('apitoken', token);
    },
    getToken() {

        let token = this.get('apitoken');

        if(!token && isLocalHost()){
            return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImFpdmFycy5sYXV6aXNAYXdhdmUuY29tIiwianRpIjoiZjdlY2U3NDMtNjMzNS00MjFjLTg0NGEtOWE1NDRhZjM2ZDEyIiwiZ2l2ZW5fbmFtZSI6IkFpdmFycyIsImZhbWlseV9uYW1lIjoiTGF1emlzIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQWRtaW4iLCJleHAiOjE1NjgyMzk1OTIsImlzcyI6Imh0dHBzOi8vcHNhZ290LXBpbG90LmF3YXZlLmlvIiwiYXVkIjoiaHR0cHM6Ly9wc2Fnb3QtcGlsb3QuYXdhdmUuaW8ifQ.Ud2bjMk6UfhaLJFcBsE88qQw-Xk-BLTLdiISGHzBOrE";
        }

        if (token){
            let expDate = parseInt(jwtDecode(token).exp,10) * 1000;
            let currDate = Date.now();

            if (expDate < currDate){
                this.clearStorage();
                oldToken();
                //logout();
                return false;
            }
        }

        return token;
    },
    setUser(userObj){
        if(userObj){
            this.set('user', JSON.stringify(userObj));
        } else {
            this.destroy('user');
        }
    },
    getUser(){
        let user = this.get('user');
        if (user){
            return JSON.parse(user);
        }
        return null;
    },
    getApiConfig(params,originalToken) {

        let h = {
            'headers': {
                'pragma': 'no-cache'
            }
        };
        if (params) {
            Object.keys(params).map((key) => {
                h[key] = params[key];
                return null;
            });
        }
        let token = this.getToken();
        if (token) {
            h.headers = {
                ...h.headers,
                'Authorization': 'Bearer ' + this.getToken(),
            }
        }

        return h;
    },
    getId() {
        let id = localStorage.getItem("id");
        if (!id) {
            id = this.generateId();
        }
        return id;
    },
    getStoragePrefixes(key) {
        let id = this.getId();
        return id + this.renderer + this.client + key;
    },
    generateId() {
        var id = makeid();
        localStorage.setItem("id", id);
        return id;
    },
    getSsoLink(ssoId) {
        let id = ssoId ? ssoId : makeid();
        return this.api.endpoint + 'api/UserSso/sso/' + id+"?returnUrl="+encodeURI(window.location.href);
    },
    getSsoId() {
        return this.get('ssoId');
    },
    setSsoId(ssoId){
        this.set('ssoId',ssoId);
    }
};


// WEBPACK FOOTER //
// ./src/core/config/index.js